module.exports = __webpack_public_path__ + "static/img/12.eec0274.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/eng/12.png
// module id = MKax
// module chunks = 0